import * as PIXI from "pixi.js";
import * as Proton from "proton-js";
import {PixiApplication} from "./PixiApplication";

export class LinearMotionWithAccelerationRendererInstance {

    private proton: Proton;

    private protonEmitter: any;
    private containerToMove: PIXI.Container;
    private startPoint: PIXI.Point;
    private finishPoint: PIXI.Point;
    private moveXFinished = false;
    private moveYFinished = false;
    private resolve: any;

    private ACCELERATION_FACTOR = 160;

    public constructor() {
        this.initializeProton();
        this.initializeProtonRenderer();
    }

    public async move(container: PIXI.Container,
                      startPoint: PIXI.Point,
                      finishPoint: PIXI.Point): Promise<void> {
        if (this.resolve) {
            throw new Error("Currently different object is being moved!");
        }
        return new Promise<void>((resolve) => {
            this.moveXFinished = false;
            this.moveYFinished = false;
            this.resolve = resolve;
            this.startPoint = startPoint;
            this.finishPoint = finishPoint;
            this.containerToMove = container;
            this.protonEmitter = new Proton.Emitter();
            this.protonEmitter.rate = new Proton.Rate(1, 0.1);
            this.protonEmitter.addInitialize(new Proton.Life(50));
            this.protonEmitter.addBehaviour(
                new Proton.Attraction({x: finishPoint.x, y: finishPoint.y}, this.ACCELERATION_FACTOR, 3000),
            );
            this.protonEmitter.p.x = startPoint.x;
            this.protonEmitter.p.y = startPoint.y;
            this.protonEmitter.emit("once");
            this.proton.addEmitter(this.protonEmitter);
        });
    }

    public isUsed(): boolean {
        return !!this.resolve;
    }

    private initializeProton(): void {
        this.proton = new Proton();
        PIXI.ticker.shared.add(() => {
            this.proton.update();
        });
    }

    private initializeProtonRenderer(): void {
        const renderer = new Proton.CanvasRenderer(document.getElementsByTagName("canvas")[0]);
        renderer.width = PixiApplication.WIDTH;
        renderer.height = PixiApplication.HEIGHT;
        renderer.onProtonUpdate = () => {
        };

        renderer.onParticleCreated = (particle: any) => {
            particle.pixiContainer = this.containerToMove;
        };

        renderer.onParticleUpdate = (particle) => {
            if ((
                    (
                        this.finishPoint.x >= this.startPoint.x &&
                        this.finishPoint.x <= particle.p.x) ||
                    (
                        this.finishPoint.x <= this.startPoint.x &&
                        this.finishPoint.x >= particle.p.x
                    )
                ) && !this.moveXFinished) {
                this.moveXFinished = true;
                particle.pixiContainer.position.x = this.finishPoint.x;
                if (this.moveXFinished && this.moveYFinished) {
                    this.proton.removeEmitter(this.protonEmitter);
                    this.tryResolvePromise();
                }
            } else if (!this.moveXFinished) {
                particle.pixiContainer.position.x = particle.p.x;
            }
            if ((
                    (
                        this.finishPoint.y >= this.startPoint.y &&
                        this.finishPoint.y <= particle.p.y
                    ) ||
                    (
                        this.finishPoint.y <= this.startPoint.y &&
                        this.finishPoint.y >= particle.p.y
                    )
                ) && !this.moveYFinished) {
                this.moveYFinished = true;
                particle.pixiContainer.position.y = this.finishPoint.y;
                if (this.moveXFinished && this.moveYFinished) {
                    this.proton.removeEmitter(this.protonEmitter);
                    this.tryResolvePromise();
                }
            } else if (!this.moveYFinished) {
                particle.pixiContainer.position.y = particle.p.y;
            }

            particle.pixiContainer.alpha = particle.alpha;
            particle.pixiContainer.rotation = particle.rotation;
        };

        this.proton.addRenderer(renderer);
    }

    private tryResolvePromise(): void {
        if (this.resolve) {
            this.resolve();
            this.resolve = undefined;
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/LinearMotionWithAccelerationRendererInstance.ts